import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AuthState } from "./auth.type";
import { Role } from "@app/constants";
import { User } from "@app/types";

const initialState: AuthState = {
  id: 0,
  email: "",
  username: "",
  fullName: "",
  point: 0,
  role: Role.USER,
  thumbnail: "",
  canCreateAudio: false,
  canUploadAudio: false,
};

const authSlice = createSlice({
  name: "@auth",
  initialState,
  reducers: {
    storeUser(state, action: PayloadAction<User>) {
      state.id = action.payload.id;
      state.email = action.payload.email;
      state.username = action.payload.username;
      state.fullName = action.payload.fullName;
      state.point = action.payload.point;
      state.role = action.payload.role;
      state.thumbnail = action.payload.thumbnail;
      state.canCreateAudio = Boolean(action.payload.canCreateAudio);
      state.canUploadAudio = Boolean(action.payload.canUploadAudio);
    },
    clearUser: () => initialState,
  },
});

export const { storeUser, clearUser } = authSlice.actions;

export default authSlice.reducer;
